
const digest = 'dc7ad5518afade152af88ee6b21439f49fad589f5d86aeadf136674791893864';
const classes = {"wrapper":"_wrapper_v1q8d_1","inLine":"_inLine_v1q8d_7","radioWrapper":"_radioWrapper_v1q8d_11","radio":"_radio_v1q8d_11","active":"_active_v1q8d_28","title":"_title_v1q8d_33","errorMessage":"_errorMessage_v1q8d_38","wrapper2":"_wrapper2_v1q8d_44"};
const css = `._wrapper_v1q8d_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
}

._inLine_v1q8d_7 {
  flex-direction: row;
}

._radioWrapper_v1q8d_11 {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

._radio_v1q8d_11 {
  width: 25px;
  height: 25px;
  background: url("/dist/icons/react/radio-default.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
}

._active_v1q8d_28 {
  background: url("/dist/icons/react/radio-selected.svg") no-repeat center;
  background-size: contain;
}

._title_v1q8d_33 {
  font-size: 14px;
  font-weight: 500;
}

._errorMessage_v1q8d_38 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}

._wrapper2_v1q8d_44 {
  display: block;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  